module.exports = __webpack_public_path__ + "img/security.6966fb6e.png";